import React, { useState, useEffect } from "react";
import Hero from "./Hero";
import Projects from "./Projects";
import Navigation from "./Navigation";

const Portfolio = () => {
  const [activeSection, setActiveSection] = useState("hero");

  useEffect(() => {
    document.title = "Andy Persaud Portfolio";
    
    const handleScroll = () => {
      const sections = ["hero", "projects"];
      const scrollY = window.scrollY + 100;

      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollY >= offsetTop && scrollY < offsetTop + offsetHeight) {
            setActiveSection(section);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation activeSection={activeSection} />
      <main>
        <Hero />
        <Projects />
        
        {/* Final CTA Section */}
        <section className="section-padding bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
          <div className="container-narrow text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 animate-fade-in">
              Ready to Create Something Amazing?
            </h2>
            <p className="text-xl opacity-90 mb-8 max-w-2xl mx-auto animate-fade-in">
              Let&apos;s collaborate to transform your ideas into exceptional user experiences 
              that drive real business results.
            </p>
            <div className="space-y-6 animate-slide-up">
              <div className="flex flex-wrap justify-center gap-6 text-lg">
                <div className="flex items-center space-x-2">
                  <span className="text-2xl">🎯</span>
                  <span>Conversion-Focused Design</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-2xl">📊</span>
                  <span>Measurable Business Results</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-2xl">⚡</span>
                  <span>Fast, Reliable Delivery</span>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <a
                  href="/contact"
                  className="bg-white text-blue-600 font-bold py-4 px-8 rounded-xl hover:bg-blue-50 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
                >
                  Hire Me for Your Project
                </a>
                <a
                  href="mailto:andy@andypersaud.com"
                  className="border-2 border-white text-white font-bold py-4 px-8 rounded-xl hover:bg-white hover:text-blue-600 transform hover:scale-105 transition-all duration-200"
                >
                  Email Me Directly
                </a>
              </div>
              
              <div className="mt-8 space-y-2">
                <p className="text-lg font-semibold">
                  Andy Persaud • Senior UX Designer
                </p>
                <p className="opacity-75">
                  Available for full-time roles (Jan 2025) • Contract projects available now
                </p>
                <p className="opacity-75">
                  New York City • Remote • Hybrid
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Portfolio;